<template>
	<div class="row">
		<div class="col-lg-8 offset-lg-2">
			<div class="common_author_form">
				<form @submit.prevent="registerUser" id="main_author_form">
					<div class="row">
						<div class="form-group">
							<input type="text" class="form-control" :placeholder="$t('name')" v-model="formData.name"
								required />
						</div>
						<div class="form-group">
							<input type="number" class="form-control" :placeholder="$t('WhatsApp*')" v-model="formData.whatsapp"
								required />
						</div>
						<div class="form-group">
							<input type="email" class="form-control" :placeholder="$t('email')" v-model="formData.email"
								required />
						</div>
						<div class="form-group">
							<input type="password" class="form-control" :placeholder="$t('password')"
								v-model="formData.password" required />
						</div>
						<div class="form-group">
							<input type="password" class="form-control" :placeholder="$t('confirm_password')"
								v-model="formData.confirmPassword" required />
						</div>
						<div class="col-12">
							<div class="form-check px-0 d-flex align-items-start">
								<label class="form-check-label d-flex align-items-start m-0">
									<input class="form-check-input mx-2" type="checkbox" v-model="formData.acceptTerms" />
									{{ $t("i_accept_terms_and_conditions") }}

									<a class="btn btn-link mx-2 p-0 small ml-2 text-info text-decoration-underline"
										href="#" @click.stop.prevent="openInNewTab">
										{{ $t('view') }}
									</a>
								</label>
							</div>
						</div>
						

						<div class="common_form_submit">
							<button type="submit" class="btn btn_theme btn_md">
								{{ $t("register") }}
							</button>
						</div>
						<div class="have_acount_area other_author_option">
							<p>
								{{ $t("already_have_account") }}
								<router-link to="/login">{{
									$t("log_in_now")
								}}</router-link>
							</p>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import { API_BASE_URL, REGISTER_OWNER_API } from "@/api-config";
import Swal from "sweetalert2";

export default {
	name: "CommonAuthorThree",
	data() {
		return {
			formData: {
				name: "",
				email: "",
				whatsapp: "",
				password: "",
				confirmPassword: "",
				acceptTerms: false,
			},
		};
	},
	computed: {
		formatDate() {
			if (!this.formData.birthDate) return "";
			const [year, month, day] = this.formData.birthDate.split("-");
			return `${year}/${month}/${day}`;
		},
	},
	methods: {
		...mapActions("form", ["updateError"]),

		showAlert(message, type) {
			Swal.fire({
				icon: type,
				title: type === "success" ? "Éxito" : "Error",
				text: message,
			}).then(() => {
				this.updateError({ status: false, message: "" });
			});
		},

		validateForm() {
			if (this.formData.password !== this.formData.confirmPassword) {
				return this.$t("passwords_do_not_match");
			}
			if (!this.formData.acceptTerms) {
				return this.$t("please_accept_terms_and_conditions");
			}
			return null;
		},

		async registerUser() {
			const validationError = this.validateForm();
			if (validationError) {
				this.showAlert(validationError, "error");
				return;
			}
			try {
				const response = await axios.post(
					`${API_BASE_URL}${REGISTER_OWNER_API}`,
					{
						name: this.formData.name,
						whatsapp: this.formData.whatsapp,
						email: this.formData.email,
						password: this.formData.password,
						password_confirmed: this.formData.confirmPassword,
					}
				);

				if (!response.data.errors) {
					this.showAlert(response.data.message, "success");
					this.$router.push("/login");
				}
			} catch (error) {
				if (
					error.response &&
					error.response.data &&
					error.response.data.message
				) {
					const errorMessage = error.response.data.message;
					this.showAlert(errorMessage, "error");
				} else {
					this.showAlert("Error desconocido");
				}
			}
		},

		openInNewTab() {
			const url = this.$router.resolve({
				name: "terms-service",
			}).href;

			window.open(url, "_blank", "noopener,noreferrer");
		},
	},
};
</script>
